module.exports = __webpack_public_path__ + "vue-app/img/ecoresponsabilite-fr-small.213b5b63.jpg";